module.exports = __webpack_public_path__ + "img/pingan.7baeaeeb.png";